export default __webpack_public_path__ + "static/media/logo-rotten-tomatoes.f60abeea.svg";